<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" label-width="120px">
            <el-form-item label="模板下载：">
                <el-link href="https://grouting-1318074248.cos.ap-nanjing.myqcloud.com/template/user_template.xlsx" target="_blank" type="primary">点击下载Excel表格模版</el-link>
            </el-form-item>
            <el-form-item label="上传文件：">
                <el-upload
                    ref="upload"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    name="upFile"
                    :action="uploadAction"
                    :headers="uploadHeaders"
                    :file-list="fileList"
                    :auto-upload="false"
                    :on-success="handleUploadSuccess"
                    :before-upload="beforeUpload">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                </el-upload>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'

export default {
    name: 'projectDivisionImp',
    mixins: [editutil],
    data() {
        return {
            uploadAction: "/api/admin/user/import",
            fileList: [],
        };
    },
    methods: {
        handleSubmit(){
            this.$refs.upload.submit();
        },
        handleUploadSuccess(res, file){
            if(res.code ==1){
                this.$msgs("导入成功！");
                this.$emit("on-imp-ok",{});
            }else{
                this.$message({
                    type: 'error',
                    duration: 0,
                    showClose: true,
                    message: res.msg
                });
            }
        },
        beforeUpload(file){
            const isLt2M = file.size / 1024 / 1024 < 5;
            if (!isLt2M) {
                this.$message.error('上传文件大小不能超过5MB!');
            }
            return isLt2M;
        },
    }
};
</script>